import { jsx } from "react/jsx-runtime";
import LogoutIcon from "@mui/icons-material/Logout";
import { validateTidalLicense } from "../../base/index.js";
function Logout(props) {
  return /* @__PURE__ */ jsx(
    LogoutIcon,
    {
      "data-testid": "Logout",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Logout",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
Logout.tidalIconMeta = {
  categories: "people,persona",
  name: "Logout"
};
validateTidalLicense();
export {
  Logout
};
//# sourceMappingURL=Logout.js.map
